export default defineNuxtRouteMiddleware(to => {
  if (process.client) {
    const initialRoute = window.sessionStorage.getItem('initialRoute')
    if (!initialRoute) {
      window.sessionStorage.setItem('initialRoute', to.fullPath)
    }
  }
})
